// @flow
import React, { PureComponent } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

import RencontreHighlights from 'components/rencontre/general/RencontreHighlights';
import RencontreTeam from 'containers/rencontre/general/RencontreTeamContainer';
import Loading from 'components/fragments/Loading';

import { withHelmet } from 'infrastructure/seo/Helmet';
import { getMidMatchScore } from 'utils/rencontreUtils';
import { getMetaBySlug } from 'utils/seoUtils';

import type { RouterProps } from 'types/Router';
import type { RencontreType } from 'types/Rencontre';

export type StateProps = {
  rencontre: ?RencontreType;
};

type Props = StateProps & RouterProps;

class RencontreGeneralResult extends PureComponent<Props> {
  render() {
    const { rencontre, match: { url } } = this.props;

    if (!rencontre) {
      return <Loading />;
    }

    const {
      actions,
      localJoueurs,
      dateEffective,
      localStructure: {
        nom: teamA,
      },
      visiteurStructure: {
        nom: teamB,
      },
    } = rencontre;
    const saison = dateEffective.getFullYear();
    const { scoreVis, scoreLoc } = getMidMatchScore(actions);
    const noAction = actions.every(action => (action.localActions.length === 0 && action.visiteurActions.length === 0));


    if (noAction && (!localJoueurs || localJoueurs.length === 0)) {
      const statsUrl = `${url.replace('/general', '')}${url[url.length - 1] === '/' ? '' : '/'}statistiques-classement`;

      return <Redirect to={statsUrl} />;
    }

    return (
      <>
        <h2 className="mt-3">{`Résumé ${teamA} - ${teamB} saison ${saison}`}</h2>
        {!noAction && (
          <div className="row mt-3">
            <div className="col col-lg-8on9">
              <RencontreHighlights
                actions={actions}
                localScoreMid={scoreLoc}
                visiteurScoreMid={scoreVis}
                isMatchEnd
              />
            </div>
          </div>
        )}
        {localJoueurs && localJoueurs.length > 0 && <RencontreTeam />}
      </>
    );
  }
}

export default withHelmet(withRouter(RencontreGeneralResult))((Helmet, pageProps) => {
  const { rencontre } = pageProps;

  const teamA = rencontre.localStructure.nom;
  const teamB = rencontre.visiteurStructure.nom;

  const meta = getMetaBySlug('match/resume');

  return (
    <Helmet>
      <title>{ meta.title(teamA, teamB) }</title>
      {
        meta.description() !== ''
        ? <meta name={'description'} content={meta.description()} />
        : ''
      }
      <meta name={'keywords'} content={meta.keywords(teamA, teamB)} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta.title(teamA, teamB)} />
      {
        meta.description() !== ''
        ? <meta property={'og:description'} content={meta.description()} />
        : ''
      }
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );  
});
